import { Component, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { BaseServiceService } from "../../services/base-service.service";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { Proceso } from "../diagram/diagram.component";
import { HttpClient } from "@angular/common/http";
import { AppData } from "../../helpers/app-data";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { lastValueFrom } from "rxjs";
import { formatCurrency } from "@angular/common";
import { DiagramViewerComponent } from "../diagram-viewer/diagram-viewer.component";
import { ModalActionButton } from "../generic-modal/generic-modal.component";

declare var fabric: any;

@Component({
  selector: "app-datatable-procesos",
  templateUrl: "./datatable-procesos.component.html",
  styleUrl: "./datatable-procesos.component.css",
})
export class DatatableProcesosComponent {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;
  @ViewChild(DiagramViewerComponent) diagramViewer!: DiagramViewerComponent;

  dialogComponentCreate: any;
  dialogComponentEdit: any;
  /*   tenantObj: Tenant;
   */ formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idProceso: any;
  getDataTableProcesos: any = ["Proceso", "GetDataTableProceso"];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api | any = null;
  dtOptButtons: any = [];

  dtOptions: DataTables.Settings = {};
  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  dialogComponentCreateProceso: any;
  dialogComponentDuplicarProceso: any;
  dialogComponentImportarProceso: any;
  processForm: FormGroup | any = null;
  procesoObj: Proceso;
  auxImport: boolean = false;
  procesoDuplicado: any = '';
  isEmpty: any = null;
  
  // Variables para el modal del diagrama
  modalDiagramaVisible: boolean = false;
  xmlContent: string = '';
  mostrarDiagrama: boolean = false;
  idProcesoTitle?: number;
  NombreProcesoTitle?: string;
  
  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };
  columnas = [
    { title: "ID", data: "Id" },
    { title: "Nombre", data: "Nombre" },  
    { title: "Descripcion", data: "Descripcion" },
    { title: "Duplicado de", data: "NombrePadre" },
    { title: "Estado", data: "Estado" },
    { title: "Version", data: "Version" },
    { title: "Fecha Creación", data: "FechaCreacionProceso" },
    { title: "Usuario Creación", data: "UsuarioCreacion" },
    { title: "Fecha Actualización", data: "FechaActualizacionProceso" },
    { title: "Usuario Actualización", data: "UsuarioActualizacion" },
    {
      title: "Todos Usuarios",
      data: "TodosUsuarios",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
    {
      title: "Activo",
      data: "Activo",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
  ];

  constructor(
    private baseService: BaseServiceService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private _formBuilder: FormBuilder
  ) {
    this.procesoObj = new Proceso();
    this.formInit();
  }

  clearFormProcesoCreado() {
    this.procesoObj = new Proceso();
    this.processForm.reset();
    this.idProceso = null;
    this.baseService.clearForm();
  }

  clearFormProceso() {
    this.baseService.triggerShowModal(
      "Cancelar creacion del proceso",
      "¿Seguro que desea cancelar la creacion del proceso?",
      ModalNotifyTypes.Warning,
      true
    );

    //this.baseService.clearForm();

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.procesoObj = new Proceso();
          this.processForm.reset();
          this.baseService.clearForm();
          this.dialogComponentCreateProceso.close();
        } else {
          // Si se cancela la eliminación, no hacemos nada
        }
      }
    );
  }

  abrirModalCrear() {
    this.clearFormProcesoCreado();
    $("#estadoProceso").prop("disabled", false);
    $("#dialogCreateEdit").html("Crear Proceso");
    $("#btnCreateEdit > span").html("Crear");
    this.processForm.controls["Activo"].setValue(true);

    const dialog = document.querySelector(".create-procesos");
    this.dialogComponentCreateProceso = new fabric["Dialog"](dialog);
    this.dialogComponentCreateProceso.open();
  }

  abrirDiagramador() {
    this.router.navigate(["home/design-process"]);
  }
  abrirEditorAcceso() {
    
    this.router.navigate(["home/acceso"]);
  }
  abrirEditorDiagramador() {
    this.router.navigate(["home/design-process"]);
  }
  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push(
      {
        "button-id": "btnEdit",
        "button-icon": "ms-Icon--EditNote",
        "button-tooltip": "Editar Datos",
      },
      {
        "button-id": "btnCopyProcess",
        "button-icon": "ms-Icon--Copy",
        "button-tooltip": "Duplicar Proceso",
      },
      {
        "button-id": "btnImport",
        "button-icon": "ms-Icon--Upload",
        "button-tooltip": "Importar",
        'conditional-data': [{ key: 'isempty', value: 'IsEmpty' }]
      },
      {
        "button-id": "btnExport",
        "button-icon": "ms-Icon--Download",
        "button-tooltip": "Exportar",
      },
      {
        "button-id": "btnVerDiagramaProceso",
        "button-icon": "ms-Icon--RedEye",
        "button-tooltip": "Ver Diagrama",
        'conditional-data': [
          { key: 'field', value: 'Nombre' }
        ]
      },
      {
        "conditional-column": "TodosUsuarios",
        "button-id": "btnAccess",
        "button-icon": "ms-Icon--UserFollowed",
        "conditional-comparison": "not",
        "button-tooltip": "Asignar Permisos",
      },
      {
        "conditional-column": "Estado",
        "conditional-datatype": "string",
        "conditional-value": "Produccion",
        "button-id": "btnEditProcess",
        "button-icon": "ms-Icon--WindowEdit",
        "conditional-comparison": "not-equals",
        "button-tooltip": "Editar Proceso",
      }
    );

   
    var CheckBoxElements = document.querySelectorAll(".ms-CheckBox");
    for (var i = 0; i < CheckBoxElements.length; i++) {
      new fabric["CheckBox"](CheckBoxElements[i]);
    }
    var DatePickerElements = document.querySelectorAll(".ms-DatePicker-holder");
    for (var i = 0; i < DatePickerElements.length; i++) {
      new fabric["DatePicker"](DatePickerElements[i]);
    }

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }
  }

  ngAfterViewInit(): void {
    /* this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.on("draw", () => {
        this.attachClickEvents();
      });
    }); */
  }

  ngOnDestroy(): void {
    // Destroy the DataTables when the component is destroyed to prevent memory leaks
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.off("draw");
      });
    }
  }

  formInit() {
    this.processForm = this._formBuilder.group({
      Nombre: new FormControl("", [
        Validators.required,
        Validators.maxLength(200),
      ]),
      Descripcion: new FormControl("", [
        Validators.required,
        Validators.maxLength(700),
      ]),
      Estado: new FormControl("", [Validators.required]),
      Version: new FormControl(null, [Validators.required]),
      TodosUsuarios: new FormControl(false),
      Activo: new FormControl(false),
    });
  }

  attachClickEvents(): void {
    const editButtons = document.querySelectorAll("#btnEdit");
    const deleteButtons = document.querySelectorAll("#btnDelete");
    const editDiagramButtons = document.querySelectorAll("#btnEditProcess");
    const editAccessButton = document.querySelectorAll("#btnAccess");
    const copyProcessButton = document.querySelectorAll("#btnCopyProcess");

    editButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const id = button.getAttribute("data-id");
        this.idProceso = id;
        this.abrirModalEditar();
      });
    });

    deleteButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.delete(Number(userId));
      });
    });
    editDiagramButtons.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.baseService.exportIDProcess(userId!);
        this.abrirEditorDiagramador();
      });
    });
    editAccessButton.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const userId = button.getAttribute("data-id");
        this.baseService.exportIDProcess(userId!);
        this.baseService.exportIsOptionMenu(false);

        this.abrirEditorAcceso();
      });
    });
    copyProcessButton.forEach((button) => {
      this.renderer.listen(button, "click", (event) => {
        const processId = button.getAttribute("data-id");
        //this.baseService.exportIDProcess(processId);
        this.idProceso = processId;
        this.abrirModalDuplicar();
      });
    });
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    try {
      
      this.idProceso = event["data-id"];

      switch (event["button-id"]) {
        case "btnEdit":
          this.abrirModalEditar();
          break;
        case "btnDelete":
          this.delete(Number(this.idProceso));
          break;
        case "btnEditProcess":
          //AppData.DIAGRAM_DATA = AppData.DIAGRAM_DATA + '?IdProceso=' + this.idProceso + '&Token=' + localStorage.getItem(AppData.localStorageToken);
          AppData.DIAGRAM_URL =
            AppData.DIAGRAM_DATA +
            "?Tipo=proceso&Id=" +
            this.idProceso +
            "&Token=" +
            sessionStorage.getItem(AppData.localStorageToken);
          console.log(AppData.DIAGRAM_URL);
          //this.baseService.exportIDProcess(this.idProceso);

          this.abrirEditorDiagramador();
          break;
        case "btnAccess":
          this.baseService.exportIDProcess(this.idProceso);
          this.baseService.exportIsOptionMenu(false);

          this.abrirEditorAcceso();
          break;
        case "btnCopyProcess":
          this.abrirModalDuplicar();
          break;
        case "btnImport":
          this.auxImport = true;
          this.isEmpty = event['data-isempty'];
          
          this.abrirModalImportar();
          break;
        case "btnExport":
          this.auxImport = false;

          this.exportarProceso();
          break;
        case "btnVerDiagramaProceso":
          this.NombreProcesoTitle = event['data-field'];
          this.idProcesoTitle = this.idProceso;
          this.cargarDiagramaProceso();
          break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  async edit(userId: number) {
    try {
      await this.baseService.setIdSeleccionado(userId);
      this.baseService.abrirModalEditar();
    } catch (error) {
      console.error("Error al establecer el ID:", error);
    }
  }

  async delete(userId: number) {
    try {
      this.baseService.triggerShowModal(
        "Eliminar Proceso",
        "¿Seguro que desea eliminar el Proceso?",
        ModalNotifyTypes.Warning,
        true
      );

      // Manejamos el evento actionConfirmed del ModalNotifyComponent
      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            // Si se confirma la eliminación, procedemos con la llamada a la API para eliminar
            this.baseService
              .delete("Proceso/BorrarProceso", userId)
              .then(() => {
                this.reloadDataTable();
                this.baseService.triggerShowModal(
                  "Proceso Eliminado",
                  "Usuario Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    this.dtInstance.ajax.reload(undefined, false);
  }

  dialogComponent: any = null;

  async crearEditarProceso() {
    this.botonProcesando = true;
    this.procesoObj.Nombre = this.processForm.get("Nombre")!.value;
    this.procesoObj.Descripcion = this.processForm.get("Descripcion")!.value;
    //this.procesoObj.Estado = parseInt(this.processForm.get('Nombre').value);
    this.procesoObj.Version = this.processForm.get("Version")!.value;
    this.procesoObj.TodosUsuarios = this.processForm.get("TodosUsuarios")!.value;
    this.procesoObj.Activo = this.processForm.get("Activo")!.value;
    this.procesoObj.Configuracion = "";
    this.procesoObj.Estado = parseInt(this.procesoObj.Estado as any);
    console.log(this.processForm.get("Activo"));
    console.log(this.processForm.get("Version")!.value);

    
    try {
      if (this.idProceso) {
        const response = await this.baseService.update(
          "Proceso/ActualizarProceso",
          this.idProceso,
          this.procesoObj
        );

        console.log(this.procesoObj);

        if (!response.Ok) {
          this.dialogComponentCreate.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al editar Proceso",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateProceso.close();
          this.baseService.triggerShowModal(
            "Proceso Editado",
            "Se ha almacenado el registro correctamente ",
            ModalNotifyTypes.Success,
            false
          );
          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } else {
        const response = await this.baseService.create(
          "Proceso/CrearProceso",
          this.procesoObj
        );

        if (!response.Ok) {
          this.dialogComponentCreateProceso.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al crear Proceso",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          this.dialogComponentCreateProceso.close();

          var example = document.querySelector(".success");

          var dialog = example!.querySelector(".modal-succes");

          this.dialogComponent = new fabric["Dialog"](dialog);

          this.dialogComponent.open();

          this.botonProcesando = false;
          this.reloadDataTable();
          //this.clearFormProcesoCreado();
        }
      }
    } catch (error: any) {
      this.dialogComponentCreateProceso.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  cerrarModal() {
    this.dialogComponent.close();
  }

  async abrirModalEditar() {
    try {
      if (this.idProceso !== null) {
        const responseById = await this.baseService.getById(
          "Proceso/GetProceso",
          this.idProceso
        );
        if (responseById.Data) {
          const Data = responseById.Data;
          this.processForm.controls["Nombre"].setValue(Data.Nombre);
          this.processForm.controls["Descripcion"].setValue(Data.Descripcion);
          this.processForm.controls["Estado"].setValue(Data.Estado);
          this.processForm.controls["Version"].setValue(Data.Version);
          this.processForm.controls["TodosUsuarios"].setValue(
            Data.TodosUsuarios
          );
          this.processForm.controls["Activo"].setValue(Data.Activo);
          // this.procesoObj.Nombre = Data.Nombre;
          // this.procesoObj.Descripcion = Data.Descripcion;
          this.procesoObj.Estado = Data.Estado;
          // this.procesoObj.Version = Data.Version;
          // this.procesoObj.TodosUsuarios = Data.TodosUsuarios;
          // this.procesoObj.Activo = Data.Activo;

          $("#dialogCreateEdit").html("Editar Proceso");
          $("#btnCreateEdit > span").html("Actualizar");

          if (Data.Estado == 3) {
            $("#estadoProceso").prop("disabled", true);
          } else {
            $("#estadoProceso").prop("disabled", false);
          }
          const dialog = document.querySelector(".create-procesos");
          this.dialogComponentCreateProceso = new fabric["Dialog"](dialog);
          this.dialogComponentCreateProceso.open();
        } else {
        }
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error",
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  abrirModalDuplicar() {
    const dialog = document.querySelector(".modal-duplicar");
    this.dialogComponentDuplicarProceso = new fabric["Dialog"](dialog);
    this.dialogComponentDuplicarProceso.open();
  }
/*   abrirModalImportar() {
    const dialog = document.querySelector(".modal-Importar");
    this.dialogComponentImportarProceso = new fabric["Dialog"](dialog);
    this.dialogComponentImportarProceso.open();
  } */
selectedFile: any;
    abrirModalImportar() {
      // Abrir el explorador de archivos para seleccionar un archivo BPMN
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".bpmn"; // Aceptar solo archivos .bpmn
    
      input.onchange = async () => {
        const file = input.files ? input.files[0] : null;
    
        if (file) {
          var ext = file.name.split(".").pop();
          if (ext !== "bpmn") {
            let mensajeError =
              "Extensión " +
              ext +
              " no válida, por favor cargue un archivo con extensión .bpmn";
            this.baseService.triggerShowModal(
              "Error al importar Proceso",
              mensajeError,
              ModalNotifyTypes.Danger,
              false
            );
          } else {
            // Guardar el archivo seleccionado para usarlo después
            this.selectedFile = file;
    
            // Abrir el modal de confirmación
            const dialog = document.querySelector(".modal-Importar");
            this.dialogComponentImportarProceso = new fabric["Dialog"](dialog);
            this.dialogComponentImportarProceso.open();
          }
        } else {
          this.baseService.triggerShowModal(
            "Error",
            "No se seleccionó ningún archivo.",
            ModalNotifyTypes.Danger,
            false
          );
        }
      };
    
      // Simular el clic en el input para abrir el explorador de archivos
      input.click();
    }

  async duplicarProceso() {
    this.botonProcesando = true;

    try {
      const response = await lastValueFrom(
        this.http.post<any>(
          AppData.API_URL + "Proceso/ClonarProceso?Id=" + this.idProceso,
          null
        )
      );

      if (!response.Ok) {
        this.dialogComponentDuplicarProceso.close();

        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al duplicar Proceso",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.dialogComponentDuplicarProceso.close();

        var example = document.querySelector(".duplicado");

        this.procesoDuplicado = response.Data['Nombre'];

        var dialog = example!.querySelector(".duplicado-succes");

        this.dialogComponent = new fabric["Dialog"](dialog);

        this.dialogComponent.open();

        this.botonProcesando = false;
        this.reloadDataTable();
      }
    } catch (error: any) {
      this.dialogComponentDuplicarProceso.close();

        let mensajeError = "<ul>";
          
          mensajeError += `<li>${error.error.Error}</li>`;
        
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al duplicar Proceso",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
    }
  }

  async importarProceso() {
    this.botonProcesando = true;
  
    if (this.selectedFile && this.idProceso !== null) {
      const formData = new FormData();
      formData.append("file", this.selectedFile); // Adjuntar el archivo con la clave 'file'
  
      // Convertimos el archivo a string sin usar FileReader
      const fileContent = await this.selectedFile.text();
  
      try {
        const response = await lastValueFrom(
          this.http.post<any>(
            `${AppData.API_URL}Proceso/ActualizarProcesoConfiguracion?Id=${Number(
              this.idProceso
            )}`,
            {
              Configuracion: fileContent,
              Import: true,
            },
            {
              headers: { "Content-Type": "application/json" }, // Enviar como JSON
            }
          )
        );
  
        if (!response.Ok) {
          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";
  
          this.baseService.triggerShowModal(
            "Error al importar Proceso",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          var example = document.querySelector(".importado-s");
          var dialog = example!.querySelector(".importado-succes");
  
          this.dialogComponent = new fabric["Dialog"](dialog);
          this.dialogComponent.open();
  
          this.botonProcesando = false;
          this.reloadDataTable();
        }
      } catch (error: any) {
        let mensajeError = error.error.Error;
  
        this.baseService.triggerShowModal(
          "Error",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      }
    } else {
      this.baseService.triggerShowModal(
        "Error",
        "No se seleccionó ningún archivo o el proceso no es válido.",
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  
    this.dialogComponentImportarProceso.close();
  }

/*   async importarProceso() {
    this.botonProcesando = true;

    // Abrir el explorador de archivos para seleccionar un archivo XML
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".bpmn"; // Aceptar solo archivos .xml

    input.onchange = async () => {
      
      const file = input.files ? input.files[0] : null;

      if (file && this.idProceso !== null) {
        var ext = file.name.split(".").pop();
        if (ext != "bpmn") {
          let mensajeError =
            "Extensión " +
            ext +
            " no valida, por favor cargue un archivo con extensión .bpmn";
          this.baseService.triggerShowModal(
            "Error al importar Proceso",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          this.botonProcesando = false;
        } else {
          // Leer el archivo como texto (string)

          const formData = new FormData();
          formData.append("file", file); // Adjuntar el archivo con la clave 'file'

          // Convertimos el archivo a string sin usar FileReader
          const fileContent = await file.text();

          

          try {
            const response = await lastValueFrom(
              this.http.post<any>(
                `${
                  AppData.API_URL
                }Proceso/ActualizarProcesoConfiguracion?Id=${Number(
                  this.idProceso
                )}`,
                {
                  Configuracion: fileContent,
                  Import: true,
                },
                {
                  headers: { "Content-Type": "application/json" }, // Enviar como JSON
                }
              )
            );

            if (!response.Ok) {
              
              //this.dialogComponentImportarProceso.close();
              let mensajeError = "<ul>";
              response.ValidationErrors.forEach((error: any) => {
                mensajeError += `<li>${error}</li>`;
              });
              mensajeError += "</ul>";

              this.baseService.triggerShowModal(
                "Error al importar Proceso",
                mensajeError,
                ModalNotifyTypes.Danger,
                false
              );
              this.botonProcesando = false;
            } else {
              //this.dialogComponentImportarProceso.close();

              var example = document.querySelector(".importado-s");
              var dialog = example.querySelector(".importado-succes");

              this.dialogComponent = new fabric["Dialog"](dialog);
              this.dialogComponent.open();

              this.botonProcesando = false;
              this.reloadDataTable();
            }
          } catch (error) {
            //this.dialogComponentImportarProceso.close();

            let mensajeError = error.error.Error;

            this.baseService.triggerShowModal(
              "Error",
              mensajeError,
              ModalNotifyTypes.Danger,
              false
            );
            this.botonProcesando = false;
          }
        }
      } else {
        this.baseService.triggerShowModal(
          "Error",
          "No se seleccionó ningún archivo o el proceso no es válido.",
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      }
    };

    // Simular el clic en el input para abrir el explorador de archivos
    input.click();
    this.botonProcesando = false;
    this.dialogComponentImportarProceso.close();
  } */

  async exportarProceso() {
        if (this.idProceso === null) {
            return;
        }

        const responseById = await this.baseService.getById(
            "Proceso/GetProcesoConfiguracion",
            this.idProceso
        );

        if (!responseById.Ok) {
            let mensajeError = "<ul>";
            responseById.ValidationErrors.forEach((error: any) => {
                mensajeError += `<li>${error}</li>`;
            });
            mensajeError += "</ul>";
            
            this.baseService.triggerShowModal(
                "Error al importar Proceso",
                mensajeError,
                ModalNotifyTypes.Danger,
                false
            );
            this.botonProcesando = false;
            return;
        }

        
        // limpia los espacios extras al inicio y final
        const xmlData = responseById.Data.Configuracion.trim();
        
        // Crear el blob especificando el tipo correcto para XML
        const blob = new Blob([xmlData], { 
            type: 'text/xml;charset=utf-8'
        });
        
        
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${responseById.Data.Nombre || 'proceso'}.bpmn`);
        link.style.display = 'none';
        
        
        document.body.appendChild(link);
        
        
        setTimeout(() => {
            link.click();
            
        
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 0);
        
    
}
  
  async cargarDiagramaProceso() {
    try {
      this.mostrarDiagrama = false;
      this.modalDiagramaVisible = true;
      
      // Llamar a la API para obtener la configuración XML del proceso
      const headers = {
        'X-APIKey': AppData.API_KEY,
        'Authorization': 'Bearer ' + sessionStorage.getItem(AppData.localStorageToken)
      };

      const response = await lastValueFrom(
        this.http.get<any>(
          `${AppData.API_URL}Proceso/GetProcesoConfiguracion?Id=${this.idProceso}`,
          { headers }
        )
      );

      if (response && response.Data && response.Data.Configuracion) {
        this.xmlContent = response.Data.Configuracion;
        this.mostrarDiagrama = true;
      } else {
        console.error('No se pudo obtener la configuración del proceso');
        this.baseService.triggerShowModal(
          "Error",
          "No se pudo cargar el diagrama del proceso",
          ModalNotifyTypes.Danger,
          false
        );
        this.cerrarModalDiagrama();
      }
    } catch (error) {
      console.error('Error al cargar diagrama:', error);
      this.baseService.triggerShowModal(
        "Error",
        "Error al cargar el diagrama del proceso",
        ModalNotifyTypes.Danger,
        false
      );
      this.cerrarModalDiagrama();
    }
  }

  cerrarModalDiagrama() {
    this.modalDiagramaVisible = false;
    this.mostrarDiagrama = false;
    this.xmlContent = '';
    this.analisisActionButtons = [];
    this.estadoAnalisisRepetitivas = { disponible: false, visible: false };
    this.estadoAnalisisCB = { disponible: false, visible: false };
  }

  analisisActionButtons: ModalActionButton[] = [];
  // Estado independiente de cada agente: el modal puede mostrar 0, 1 o los 2 botones a la vez
  // (uno para Repetitivas, otro -ícono de botella- para Cuellos de Botella), según lo almacenado
  // en el XML del proceso.
  private estadoAnalisisRepetitivas: { disponible: boolean; visible: boolean } = { disponible: false, visible: false };
  private estadoAnalisisCB: { disponible: boolean; visible: boolean } = { disponible: false, visible: false };

  onAnalisisStateChange(state: { disponible: boolean; visible: boolean }) {
    this.estadoAnalisisRepetitivas = state;
    this.actualizarBotonesAnalisis();
  }

  /** Análogo a onAnalisisStateChange, pero para el hallazgo de Cuellos de Botella. */
  onAnalisisCBStateChange(state: { disponible: boolean; visible: boolean }) {
    this.estadoAnalisisCB = state;
    this.actualizarBotonesAnalisis();
  }

  private actualizarBotonesAnalisis(): void {
    const botones: ModalActionButton[] = [];

    if (this.estadoAnalisisRepetitivas.disponible) {
      botones.push({
        id: "toggleAnalisis",
        icon: this.estadoAnalisisRepetitivas.visible ? "ms-Icon--RedEye" : "ms-Icon--View",
        tooltip: this.estadoAnalisisRepetitivas.visible
          ? "Ocultar análisis de actividades repetitivas"
          : "Mostrar análisis de actividades repetitivas"
      });
    }

    if (this.estadoAnalisisCB.disponible) {
      const claseEstado = this.estadoAnalisisCB.visible ? "bsp-icon-botella--activo" : "";
      botones.push({
        id: "toggleAnalisisCB",
        icon: `fas fa-wine-bottle bsp-icon-botella ${claseEstado}`.trim(),
        tooltip: this.estadoAnalisisCB.visible
          ? "Ocultar análisis de cuellos de botella"
          : "Mostrar análisis de cuellos de botella"
      });
    }

    this.analisisActionButtons = botones;
  }

  onModalActionButtonClick(id: string) {
    if (id === "toggleAnalisis" && this.diagramViewer) {
      this.diagramViewer.toggleAnalisis();
    } else if (id === "toggleAnalisisCB" && this.diagramViewer) {
      this.diagramViewer.toggleAnalisisCuellosBotella();
    }
  }

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.valueAsNumber < 0) {
      inputElement.value = "0"; // Restablece a 0 si el valor es negativo
    }
  }
  
  async downloadProcesoPDF() {
    try {
      if (!this.diagramViewer) {
        console.error('No se encontró el componente diagram-viewer');
        this.baseService.triggerShowModal(
          "Error",
          "No se puede descargar el diagrama en este momento",
          ModalNotifyTypes.Danger,
          false
        );
        return;
      }

      // Generar nombre de archivo con información del proceso
      const nombreArchivo = `Proceso_${this.idProcesoTitle}_${this.NombreProcesoTitle?.replace(/\s+/g, '_') || 'diagrama'}.png`;
      
      // Llamar al método de exportación del diagram-viewer
      await this.diagramViewer.exportAsImage(nombreArchivo);
      
    } catch (error) {
      console.error('Error al descargar el diagrama:', error);
      this.baseService.triggerShowModal(
        "Error",
        "Error al descargar el diagrama del proceso",
        ModalNotifyTypes.Danger,
        false
      );
    }
  }
}